import { useCallback, useEffect, useRef, useState } from 'react';
import { message } from 'antd';

/**
 * 财务列表通用分页/查询 hook。
 * api 接收 { ...query, pageNum, pageSize }，返回 { rows, total }。
 */
export default function useFinanceTable(api) {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState({});
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const requestId = useRef(0);

  const load = useCallback(
    async (nextQuery, nextPagination) => {
      const currentRequest = ++requestId.current;
      setLoading(true);
      try {
        const res = await api({
          ...nextQuery,
          pageNum: nextPagination.current,
          pageSize: nextPagination.pageSize,
        });
        if (currentRequest === requestId.current) {
          setData(res?.rows || []);
          setTotal(res?.total || 0);
        }
      } catch (error) {
        if (currentRequest === requestId.current) {
          message.error(error?.message || '查询失败');
        }
      } finally {
        if (currentRequest === requestId.current) {
          setLoading(false);
        }
      }
    },
    [api]
  );

  const { current, pageSize } = pagination;

  useEffect(() => {
    load(query, { current, pageSize });
  }, [query, current, pageSize, load]);

  const search = (nextQuery) => {
    setQuery({ ...nextQuery });
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const reset = () => {
    setQuery({});
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const reload = () => load(query, pagination);

  return {
    data,
    total,
    loading,
    query,
    pagination,
    search,
    reset,
    reload,
    onTableChange: (page, pageSize) => setPagination({ current: page, pageSize }),
  };
}
